import * as Sentry from '@sentry/react';

interface ITrackEventData {
  event: string;
  properties?: object;
}

export const trackAnalyticEvent = ({
  event,
  properties,
}: ITrackEventData): void => {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event,
      ...properties,
    });
  } catch (error) {
    Sentry.captureException(error);
  }
};
